import * as React from 'react';

import * as styles from './GeoInputAddonSection.css';

export const GeoInputAddonSection: React.FC = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
